<template>
  <div class="bg-white max-w-lg my-4">
    <a-list bordered :data-source="suspiciousVariations">
      <h3 slot="header" class="text-xl font-semibold">SUSPICIOUS VARIATIONS</h3>
      <a-list-item slot="renderItem" slot-scope="item">
        <div class="w-full">
          <h3 class="text-lg font-bold">{{ item.className }}</h3>
          <div class="flex">
            <div class="mr-4">
              Share value (
              <span
                class="cursor-pointer text-terracotta hover:underline"
                @click="editReport(item.firstPeriod)"
              >
                {{ item.firstPeriod.year }} - {{ item.firstPeriod.month }}
              </span>
              ): {{ item.firstShareValue }}
            </div>
            <div class="ml-4">
              Share value (
              <span
                class="cursor-pointer text-terracotta hover:underline"
                @click="editReport(item.secondPeriod)"
              >
                {{ item.secondPeriod.year }} - {{ item.secondPeriod.month }}
              </span>
              ): {{ item.secondShareValue }}
            </div>
          </div>
        </div>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    fundId: {
      type: String,
      required: true,
    },
  },
  apollo: {
    suspiciousVariations: {
      query: gql`
        query GetSuspiciousVariations($fundId: Uuid!) {
          suspiciousVariations(fundId: $fundId) {
            className
            firstPeriod {
              year
              month
            }
            secondPeriod {
              year
              month
            }
            firstShareValue
            secondShareValue
          }
        }
      `,
      variables() {
        return {
          fundId: this.fundId,
        }
      },
    },
  },
  data() {
    return {
      suspiciousVariations: [],
    }
  },
  methods: {
    editReport(period) {
      this.$emit('editReport', period)
    },
    reload() {
      this.$apollo.queries.suspiciousVariations.refetch()
    },
  },
}
</script>

<style></style>
